import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectItem } from '../../models/base.models';

@Component({
  selector: 'app-space-item',
  templateUrl: './space-item.component.html',
  styleUrls: ['./space-item.component.css']
})
export class SpaceItemComponent implements OnInit {
  @Input() spaceItem: ProjectItem;
  @Input() isActive: boolean;

  @Output() OnItemClick = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  onItemClick() {
    this.OnItemClick.emit();
  }

}
